const linkClass =
  "group flex items-center gap-2.5 rounded-lg px-1 py-1.5 text-sm font-medium text-[#6b6585] transition-colors hover:bg-violet-light/40 hover:text-violet-fuerte";

function TocItems({ items, gridOnMobile = false }) {
  const liEl = (item) => (
    <li key={item.href}>
      <a href={item.href} className={linkClass}>
        <span className="flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-[7px] bg-[#f0eeff] text-[11px] font-bold text-violet-fuerte transition-colors group-hover:bg-violet-fuerte group-hover:text-white">
          {item.n}
        </span>
        <span className="min-w-0 leading-snug">{item.label}</span>
      </a>
    </li>
  );

  return (
    <ol className={gridOnMobile ? "grid list-none grid-cols-2 gap-x-3 sm:gap-x-5" : "list-none space-y-0.5"}>
      {items.map(liEl)}
    </ol>
  );
}

/**
 * Panel visual del índice. Se usa tanto en móvil (inline) como en el aside sticky de escritorio.
 */
export function LegalTocPanel({ ariaLabel, tocItems, title = "Índice", gridOnMobile = false }) {
  return (
    <nav
      aria-label={ariaLabel}
      className="rounded-2xl border border-violet-light/90 border-l-[5px] border-l-violet-fuerte bg-white p-5 shadow-[0_4px_24px_-12px_rgba(26,17,53,0.14)] sm:p-6"
    >
      <p className="mb-3.5 text-[11px] font-bold uppercase tracking-[0.14em] text-violet-fuerte">{title}</p>
      <TocItems items={tocItems} gridOnMobile={gridOnMobile} />
    </nav>
  );
}

/**
 * Versión móvil/tablet del índice (inline, se oculta en lg+).
 */
export default function LegalTocMobile({ ariaLabel, tocItems, title = "Índice" }) {
  return (
    <div className="mt-8 lg:hidden">
      <LegalTocPanel ariaLabel={ariaLabel} tocItems={tocItems} title={title} gridOnMobile />
    </div>
  );
}
